@if (depositsEnabled()) {
  <form class="flex flex-col gap-1" [formGroup]="form()" (ngSubmit)="submit()">
    <mat-form-field>
      <mat-label>Deposit description</mat-label>
      <input matInput formControlName="description" />
    </mat-form-field>

    <mat-form-field>
      <mat-label>Amount</mat-label>
      <span matTextPrefix>$&nbsp;</span>
      <input
        matInput
        type="number"
        min="0"
        step="0.01"
        formControlName="amount"
      />
    </mat-form-field>

    <mat-form-field>
      <mat-label>Payment Method</mat-label>
      <mat-select formControlName="method">
        @for (group of optionGroups$ | async; track group.label) {
          <mat-optgroup [label]="group.label">
            @for (option of group.options; track option.label) {
              <mat-option [value]="option">{{ option.label }}</mat-option>
            }
          </mat-optgroup>
        }
      </mat-select>
    </mat-form-field>

    <div class="flex items-center justify-between gap-2">
      <button
        type="button"
        mat-stroked-button
        aria-label="Back to deposit options"
        [disabled]="capturing()"
        (click)="goBack()"
      >
        <mat-icon>arrow_back</mat-icon>
        Back
      </button>
      <button
        type="submit"
        mat-flat-button
        color="primary"
        aria-label="Take deposit payment"
        [disabled]="(submitDisabled$ | async) || capturing()"
      >
        @if (capturing()) {
          <mat-spinner diameter="20" />
        } @else {
          Take Payment
        }
      </button>
    </div>
  </form>
}
